module.exports = __webpack_public_path__ + "img/softwaretest.a53aed55.svg";